import { axiosUser, axiosRegister } from "@config/axiosConfig";
import {
  GSTDetailsPayload,
  SubmitOrganisationDetailsPayload,
  UserRegisterPayload,
} from "@modules/register/types";
import axios from "axios";

export const aadharRegister = async () => {
  return await axiosRegister.post(`/aadhar-register`);
};

// export const aadharRegister = async () => {
//   return await axios.post(`http://localhost:3004/backend/api/register/aadhar-register`);
// };

export const userRegistrationAPI = async (payload: UserRegisterPayload) => {
  const { aadhaar_number } = payload;
  return await axiosUser.post(`/aadhaar-register`, {
    aadhaar_number,
  });
};

export const fetchGSTDetailsAPI = async (payload: GSTDetailsPayload) => {
  const { gst_number } = payload;
  return await axiosUser.post(`/fetch_gst_data`, {
    gst_number,
  });
};

export const submitUserRegistrationDetailsAPI = async (
  payload: SubmitOrganisationDetailsPayload
) => {
  const {
    user_id,
    cin,
    tin,
    mobile_number,
    email,
    gst_number,
    business_name,
    business_nature,
    entity_type,
    pincode,
    registration_date,
    state_name,
    city_name,
    district_name,
    building_number,
  } = payload;
  return await axiosUser.post(`/submit_gst`, {
    user_id,
    cin,
    tin,
    mobile_number,
    email,
    gst_number,
    business_name,
    business_nature,
    entity_type,
    pincode,
    registration_date,
    state_name,
    city_name,
    district_name,
    building_number,
  });
};


